import { render, staticRenderFns } from "./InsuranceForm.vue?vue&type=template&id=187ae81c&scoped=true"
import script from "./InsuranceForm.vue?vue&type=script&lang=ts"
export * from "./InsuranceForm.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceForm.vue?vue&type=style&index=0&id=187ae81c&prod&scoped=true&lang=css"
import style1 from "./InsuranceForm.vue?vue&type=style&index=1&id=187ae81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ae81c",
  null
  
)

export default component.exports